module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared-components/tables/regular-tables/regular-tables.component.scss
// module id = ./src/app/shared-components/tables/regular-tables/regular-tables.component.scss
// module chunks = main